import { render, staticRenderFns } from "./structureDetail.vue?vue&type=template&id=d56939a4&scoped=true&"
import script from "./structureDetail.vue?vue&type=script&lang=js&"
export * from "./structureDetail.vue?vue&type=script&lang=js&"
import style0 from "./structureDetail.vue?vue&type=style&index=0&id=d56939a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56939a4",
  null
  
)

export default component.exports